export enum ELoyaltyRewardType {
  NONE = 1,
  REWARD = 2,
  DEAL = 3,
  BIRTHDAY = 4,
  SIGNUP = 5,
  SOCIAL_FACEBOOK = 6,
  SOCIAL_TWITTER = 7,
}
